import { EmailTemplateContentValidationErrorEnum } from "../enums/EmailTemplateContentValidationErrorEnum";
import { TFunction } from "i18next";
import { TemplateContent } from "@pulse/pulse-rpcs/lib/email-cycle/templateContent";
import { BoundedNameValidationError } from "../../enums/BoundedNameValidationError";
import { BoundedName } from "@pulse/pulse-rpcs/lib/types/boundedName";

interface ValidationErrorType {
  name?: BoundedNameValidationError;
  content?: EmailTemplateContentValidationErrorEnum;
}

const getEmailTemplateNameValidationErrorMessage = (
  t: TFunction,
  validationError: BoundedNameValidationError,
): string => {
  switch (validationError) {
    case BoundedNameValidationError.MinSize:
      return t("emailTemplates.titleMinSizeValidationErrorMessage");
    case BoundedNameValidationError.MaxSize:
      return t("emailTemplates.titleMaxSizeValidationErrorMessage", {
        maxSize: BoundedName.constraints.name.maxSize,
      });
    case BoundedNameValidationError.DuplicateName:
      return t("emailTemplates.duplicateTitleValidationErrorMessage");
    default:
      return validationError satisfies never;
  }
};

const getEmailTemplateContentValidationErrorMessage = (
  t: TFunction,
  validationError: EmailTemplateContentValidationErrorEnum,
): string => {
  switch (validationError) {
    case EmailTemplateContentValidationErrorEnum.MinSize:
      return t("emailTemplates.contentMinSizeValidationErrorMessage");
    case EmailTemplateContentValidationErrorEnum.MaxSize:
      return t("emailTemplates.contentMaxSizeValidationErrorMessage", {
        maxSize: TemplateContent.constraints.content.maxSize,
      });
    default:
      return validationError satisfies never;
  }
};

export const getEmailTemplateValidationErrorMessage = (
  t: TFunction,
  validationErrors: ValidationErrorType,
): Record<keyof ValidationErrorType, string | undefined> => ({
  name: validationErrors.name
    ? getEmailTemplateNameValidationErrorMessage(t, validationErrors.name)
    : undefined,
  content: validationErrors.content
    ? getEmailTemplateContentValidationErrorMessage(t, validationErrors.content)
    : undefined,
});
